import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Welcome from './components/Welcome';
import StudentLogin from './components/student/StudentLogin';
import TeacherLogin from './components/teacher/TeacherLogin';
import AdminLogin from './components/admin/AdminLogin';
import StudentDashboard from './components/student/StudentDashboard';
import TeacherDashboard from './components/teacher/TeacherDashboard';
import AdminDashboard from './components/admin/AdminDashboard';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loggedInUser = localStorage.getItem('user');
    if (loggedInUser) {
      try {
        const userData = JSON.parse(loggedInUser);
        if (userData && userData.role) {
          setUser(userData);
        }
      } catch (error) {
        localStorage.removeItem('user');
      }
    }
    setLoading(false);
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Welcome Page */}
          <Route path="/" element={<Welcome />} />
          
          {/* Login Routes */}
          <Route path="/student-login" element={<StudentLogin onLogin={handleLogin} />} />
          <Route path="/teacher-login" element={<TeacherLogin onLogin={handleLogin} />} />
          <Route path="/admin-login" element={<AdminLogin onLogin={handleLogin} />} />
          
          {/* Dashboard Routes */}
          <Route 
            path="/student-dashboard" 
            element={
              user && user.role === 'student' ? 
                <StudentDashboard user={user} onLogout={handleLogout} /> : 
                <Navigate to="/student-login" replace />
            } 
          />
          <Route 
            path="/teacher-dashboard" 
            element={
              user && user.role === 'teacher' ? 
                <TeacherDashboard user={user} onLogout={handleLogout} /> : 
                <Navigate to="/teacher-login" replace />
            } 
          />
          <Route 
            path="/admin-dashboard" 
            element={
              user && user.role === 'admin' ? 
                <AdminDashboard user={user} onLogout={handleLogout} /> : 
                <Navigate to="/admin-login" replace />
            } 
          />
          
          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;